import * as saleSchemas from "shadow-client/endpoints/saleApi/schemas";
import { denormalize } from "normalizr";
import { getCartArticleIds, getCartSaleId } from "../modules/cart";
import { getEntities, getSale } from "shadow-client/redux/selectors";

export const getCart = state => state.cart;

export const getCartSale = state => {
  const saleId = getCartSaleId(getCart(state));

  return getSale(state, saleId);
};

export const getCartArticles = state => {
  const articleIds = getCartArticleIds(getCart(state));

  return denormalize(articleIds, [saleSchemas.cartArticle], getEntities(state));
};



// WEBPACK FOOTER //
// ./src/app/redux/selectors/index.js